module.exports = __webpack_public_path__ + "img/canada-other-heart-diseases-male.2e0245e1.png";